import { Loader, withModalContext } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useActivityUtil } from 'ent-capability-hooks';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ActivitiesService, UserService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import {
    SelectProducerCode,
    withProducerContext,
} from 'gw-gateway-common-react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'ent-capability-gateway-react/Activities/Activities.messages';
import ActivityTableComponent from 'ent-capability-gateway-react/components/ActivityTableComponent/ActivityTableComponent';
import twiagatewayMessages from '../twiagateway.messages';
import styles from './Landing.module.scss';
import metadata from './LandingPage.metadata.json5';

const accountPermCheckDTO = {
    permEntityType: 'Account',
    permEntityID: null,
    permission: 'create',
    isCheckPermEntity: false,
};

const permissionDTO = {
    permission: 'createsubmission',
};

const newQuoteAccountURL = '/new-quote-account-search';

class LandingPage extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        jobsCreatedInLastXDays: PropTypes.number,
        producerCode: PropTypes.string.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
    };

    static defaultProps = {
        jobsCreatedInLastXDays: 96,
    };

    static contextType = TranslatorContext;

    localeService = ServiceManager.getService('locale-service');

    state = {
        canCreateSubmission: false,
        canCreateAccount: false,
        activitiesAllCompletedCount: 0,
        activitiesCanceledCount: 0,
        activitiesFuture: [],
        activitiesOverdue: [],
        activitiesThisWeek: [],
        activitiesToday: [],
        activitiesTomorrow: [],
        allCompletedActivityTileStatus: false,
        allCancelledActivityTileStatus: false,
        displayNoActivities: false,
        openCancellations: 0,
        openPolicyChanges: 0,
        openRenewals: 0,
        openSubmissions: 0,
        isLoading: true,
        activityResponseData: []
    };

    componentDidMount() {
        this.checkCanCreateSubmission();
        this.checkCanCreateAccount();
        this.getActivitySummaries();
        this.getAccountJobsSummariesForCurrentUser();

        const activeLanguage = localStorage.getItem('selectedLanguage');

        if (activeLanguage === undefined) {
            localStorage.setItem(
                'selectedLanguage',
                this.localeService.getPreferredLocale()
            );
        }
    }

    checkCanCreateSubmission = async () => {
        const { authHeader } = this.props;
        const canCreateSubmission = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );

        this.setState({ canCreateSubmission });
    };

    checkCanCreateAccount = async () => {
        const { authHeader } = this.props;

        const canCreateAccount = await UserService.hasUserPermission(
            accountPermCheckDTO,
            authHeader
        );

        this.setState({ canCreateAccount });
    };

    getAccountJobsSummariesForCurrentUser = async (selectedProducerCode) => {
        const { 
            authHeader, 
            producerCode, 
            jobsCreatedInLastXDays, 
        } = this.props;
        this.setState({ isLoading: true });
        const userData = await UserService.getGatewayCurrentUser(authHeader);
        const producer =  selectedProducerCode || 'all'  //DE18356
        const rpcCall = AccountService.getAccountJobsSummariesForCurrentUser_TWIA;
        
        const jobsResult = await rpcCall(producer, jobsCreatedInLastXDays, null, null, authHeader);
        const accountJobsSummary = jobsResult.find(res => res.producerCode === producerCode);
        this.setState({
            openCancellations: accountJobsSummary?.openCancellations,
            openPolicyChanges: accountJobsSummary?.openPolicyChanges,
            openRenewals: accountJobsSummary?.openRenewals,
            openSubmissions: accountJobsSummary?.openSubmissions,
            isLoading: false,
        });
    };

    getBreakpointTracker = () => <BreakpointTrackerContext.Consumer />;

    createNote = async (data, publicID) => {
        const { authHeader, modalContext } = this.props;
        const { activityResponseData } = this.state;
        const activityNoteData = await ActivitiesService.createNoteForActivity(
            publicID,
            data,
            authHeader
        );
        const activityObj = activityResponseData.find(
            obj => obj.publicID === publicID
        );

        activityObj.notes.push(activityNoteData);
        
        if (!_.isUndefined(activityNoteData)) {
            modalContext
                .showAlert({
                    title: twiagatewayMessages.noteCreated,
                    message: twiagatewayMessages.noteCreatedSuccessfully,
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                })
                .then(() => {
                    this.getResponseData(activityResponseData);
                }, _.noop);
        }
    };

    handleValueChange = producerCode => {
        this.getAccountJobsSummariesForCurrentUser(producerCode);
    };

    getActivitySummaries = () => {
        const { authHeader } = this.props;
        
        ActivitiesService.getActivitiesForUser(authHeader).then(response => {
            const activities = _.map(response, activity => _.extend({}, activity, { expanded: false }));

            this.setState({ activitiesResult: activities });
            this.getResponseData(activities);
        });
    };

    
    onClickComplete = data => {
        const { activitiesResult } = this.state;
        const { authHeader } = this.props;
        const activityObj = activitiesResult.find(obj => obj.publicID === data);

        ActivitiesService.markActivityAsCompleted(data, authHeader).then(
            completeActivity => {
                if (activityObj) {
                    activityObj.status = completeActivity.status;
                    activityObj.closeDate = completeActivity.closeDate;
                    activityObj.completedDate = completeActivity.completedDate;
                    activityObj.canComplete = false;
                }

                this.setState({
                    publicId: data,
                    activitiesResult: [...activitiesResult, activityObj],
                });
            }
        );
    };

    

    getResponseData = activitiesResponse => {
        const { activitiesFutureData, activitiesOverdueData, activitiesTodayData, activitiesThisWeekData, activitiesTomorrowData} = useActivityUtil();
        const activityUndefinedOverdue = [];
        const activitiesData = [];
        let activityOverdue = [];

        activitiesResponse.forEach(activitiesInfo => {
            if (
                _.isUndefined(activitiesInfo.dueDate) &&
                activitiesInfo.status !== 'complete'
            ) {
                activityUndefinedOverdue.push(activitiesInfo);
            } else {
                activitiesData.push(activitiesInfo);
            }
        });

        const activitiesFuture = activitiesFutureData(  activitiesData,  'open' ).filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);
        const activitiesOverdue = activitiesOverdueData(activitiesData, 'open').filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);
        const activitiesToday = activitiesTodayData(  activitiesData, 'open' ).filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);
        const activitiesThisWeek = activitiesThisWeekData(  activitiesData, 'open' ).filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);
        const activitiesTomorrow = activitiesTomorrowData(  activitiesData, 'open' ).filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);
        
        activityOverdue = activityUndefinedOverdue.filter(activitiesInfo => activitiesInfo.isAssignedToCurrentUser);

        if (
            activitiesOverdue.length === 0 &&
            activitiesToday.length === 0 &&
            activitiesFuture.length === 0 &&
            activitiesTomorrow.length === 0
        ) {
            this.setState({
                displayNoActivities: true,
                activitiesOverdue,
                activitiesToday,
                activitiesFuture,
                activitiesThisWeek,
                activitiesTomorrow,
                activityResponseData: activitiesData,
            });
        } else {
            this.setState({
                activitiesOverdue: activityOverdue.concat(
                    _.orderBy(activitiesOverdue, 'dueDate', 'asc')
                ),
                activitiesToday: _.sortBy(activitiesToday, 'dueDate'),
                activitiesFuture: _.sortBy(activitiesFuture, 'dueDate'),
                activitiesThisWeek: _.sortBy(activitiesThisWeek, 'dueDate'),
                activitiesTomorrow: _.sortBy(activitiesTomorrow, 'dueDate'),
                displayNoActivities: false,
                activityResponseData: activitiesData,
            });
        }
    };

    handleTilesOnClick = id => {
        let pathRedirect = '';
        const { history } = this.props;

        switch (id) {
            case 'openQuotesTile':
                pathRedirect = {
                    pathname: 'policies',
                    state: {
                        selectedTile: 'quotes',
                    },
                };
                break;
            case 'policyChangeTile':
                pathRedirect = {
                    pathname: 'policies',
                    state: {
                        selectedTile: 'change',
                    },
                };
                break;
            case 'cancellationTile':
                pathRedirect = {
                    pathname: 'policies',
                    state: {
                        selectedTile: 'cancellation',
                    },
                };
                break;
            case 'renewalTile':
                pathRedirect = {
                    pathname: 'policies',
                    state: {
                        selectedTile: 'renewal',
                    },
                };
                break;
            default:
                break;
        }

        return history.push(pathRedirect);
    };

    goToNewQuote = () => {
        const { history } = this.props;

        return history.push(newQuoteAccountURL);
    };

    goToNewAgent = () => {
        const { history } = this.props;

        return history.push("/new-agent");
    };

    render() {
        const breakpointContext = this.getBreakpointTracker();
        const {
            type: { _currentValue: breakpoint },
        } = breakpointContext;
        const {
            allCompletedActivityTileStatus,
            allCancelledActivityTileStatus,
            activitiesOverdue,
            activitiesToday,
            activitiesFuture,
            displayNoActivities,
            activitiesThisWeek,
            activitiesTomorrow,
            activitiesCanceledCount,
            activitiesAllCompletedCount,
            openSubmissions,
            openCancellations,
            openRenewals,
            openPolicyChanges,
            isLoading,
            publicId,
            canCreateSubmission,
            canCreateAccount
        } = this.state;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            policyChangeTile: {
                value: openPolicyChanges,
                tileSize: breakpoint === 'tablet' ? 'medium' : 'large',
            },
            openQuotesTile: {
                value: openSubmissions,
                tileSize: breakpoint === 'tablet' ? 'medium' : 'large',
            },
            cancellationTile: {
                value: openCancellations,
                tileSize: breakpoint === 'tablet' ? 'medium' : 'large',
            },
            renewalTile: {
                value: openRenewals,
                tileSize: breakpoint === 'tablet' ? 'medium' : 'large',
            },
            allCompletedActivityTile: {
                value: activitiesAllCompletedCount,
                active: allCompletedActivityTileStatus,
            },
            allCancelledActivityTile: {
                value: activitiesCanceledCount,
                active: allCancelledActivityTileStatus,
            },
            activitiesTableContainer: {
                activitiesOverdue,
                activitiesToday,
                activitiesTomorrow,
                activitiesThisWeek,
                activitiesFuture,
                activitiesComplete: [],
                displayNoActivities,
                createNote: this.createNote,
                onClickComplete: this.onClickComplete,
                publicId
            },
            startNewQuoteBtn: {
                visible: canCreateAccount && canCreateSubmission,
            },
            mediaSideBarContainer: {
                visible: this.props.authUserData?.associationName_TWIA === 'twia',
            },
            mediaSideBarContainerTFPA: {
                visible: this.props.authUserData?.associationName_TWIA ==='tfpa',
            },
            mediasideBarComponent: {
                uwCompany: this.props.authUserData?.associationName_TWIA
            },
            mediasideBarComponentTFPA: {
                uwCompany: this.props.authUserData?.associationName_TWIA
            }
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                selectproducercode: SelectProducerCode,
                activitytablecomponent: ActivityTableComponent,
            },
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick,
                handleFilterClick: this.handleFilterClick,
                handleValueChange: this.handleValueChange,
                goToNewQuote: this.goToNewQuote,
                goToNewAgent: this.goToNewAgent
            },
        };
        const landingPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        
        return <div className={styles.landingStyles}>{landingPage}</div>;
    }
}

export const LandingPageComponent = withModalContext(LandingPage);
export default withRouter(
    withAuthenticationContext(
        withProducerContext(withModalContext(LandingPage))
    )
);
